import { ClockIcon } from '@heroicons/react/24/outline'
import type { SpinScopeStatus } from '../../Repository/Visualization/SpinMeta.js'
import type { SpinStatusDescription } from '../../Model/Spin/spinStatus.js'
import { useSpinState } from './useSpinMeta.ts'

/** The scope's per-order SPIN status, requested only while `enabled`; undefined until loaded, or after a failure with nothing cached. */
export function useSpinScopeStatus(scopeId: string | undefined, enabled: boolean): SpinScopeStatus | undefined {
  const entry = useSpinState(scopeId, enabled)
  return enabled && scopeId ? entry.data?.status : undefined
}

/**
 * A muted "SPINs pending" badge with the full sentence as its tooltip; renders nothing unless clustering is
 * outstanding — available SPINs need no announcement. `showDetail` adds the sentence inline, for panels with room.
 */
export function SpinPendingBadge({
  description,
  showDetail = false,
  className = ''
}: {
  description: SpinStatusDescription
  showDetail?: boolean
  className?: string
}) {
  if (description.kind !== 'pending') return null
  return (
    <span data-testid="spin-pending-badge" title={description.text} className={`inline-flex items-center gap-2 text-xs font-normal ${className}`}>
      <span className="badge badge-sm badge-ghost gap-1 text-slate-500 whitespace-nowrap">
        <ClockIcon className="w-3 h-3" />
        {description.title}
      </span>
      {showDetail && description.detail && <span className="text-slate-500">{description.detail}</span>}
    </span>
  )
}
